<template>
    <div></div>
</template>

<script setup lang="ts">
     import { useRoute } from 'vue-router'
     import { useUserStore } from '@/stores/userStore'
     import { languageService } from '@/services/languageService'
     import { navigationService } from '@/services/navigationService'
     import { useI18n } from 'vue-i18n'
    
     const route = useRoute()
     const userStore = useUserStore()
     const { locale } = useI18n()
    
     async function loginUser() {
         try {
             const token = route.query.accessToken
             if (typeof token === 'string') {
                 await userStore.login(token)
                 locale.value = languageService.getLocale()
                 navigationService.goHomePage()
             } else {
                 navigationService.goAnonymousPage()
             }
         } catch (error) {
             console.log("User login error", error)
             navigationService.goAnonymousPage()
         }
     }
     loginUser()
</script>